import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { AppContext } from "components/app/RemExprertProvider";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import RemExpressContratFacProModal from "pages/audit rémunération/contratfacultatifpro pager";
import React, { useContext, useState } from "react";
import { FaGlobe, FaUser, FaFileContract, FaMoneyBillWave, FaFileInvoiceDollar, FaBuilding } from "react-icons/fa";
import CompactFinancialCard from "./CompactFinancialCard";

function RemExpressRemunerationTns(props) {
  const { Prenom, ClientConjoint } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalContrat, setModalContrat] = useState(false);  return (
    <div style={{
      background: '#ffffff',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)',      border: '1px solid rgba(0,0,0,0.06)',
      margin: '5px 0'
    }}>      {/* Titre de section */}
      <div style={{
        fontSize: '12px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        fontWeight: 600,
        color: '#1f2937',
        margin: '0 0 4px 0',
        letterSpacing: '-0.02em'
      }}>
        Rémunération TNS
      </div>
      
      {/* Sous-titre */}
      <div style={{
        fontSize: '12px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        fontWeight: 400,
        color: '#6b7280',
        margin: '0 0 12px 0',
        letterSpacing: '-0.01em',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        paddingBottom: '8px'
      }}>
        Détail de la rémunération pour {Prenom}
      </div>

      {/* Cartes financières compactes */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        
        <CompactFinancialCard
          title={`Budget rémunération pour ${Prenom}`}
          value={context.state.RemExpressCoutRemuneration}
          icon={<FaUser style={{ color: '#059669' }} />}
          accentColor="#059669"
          isEditable={true}
          onChange={(e) => context.handleCalculRemExpress("cout_remuneration","RemExpressCoutRemuneration", ResultatTNS, e)}
          dataType="uint"
          format={{ thousands: " ", unit: " €" }}
        />

        <CompactFinancialCard
          title="Cotisations obligatoires et facultatives"
          value={applyFormat(context.state.RemExpressCotisations, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          icon={<FaFileContract style={{ color: '#dc2626' }} />}
          accentColor="#dc2626"
          onEdit={() => setModalContrat(true)}
        />

        <CompactFinancialCard
          title="Rémunération nette"
          value={context.state.RemExpressRemNette}
          icon={<FaMoneyBillWave style={{ color: '#2563eb' }} />}
          accentColor="#2563eb"
          isEditable={true}
          onChange={(e) => context.handleCalculRemExpress("remuneration_nette", "RemExpressRemNette" , ResultatTNS, e)}
          dataType="uint"
          format={{ thousands: " ", unit: " €" }}
        />

        <CompactFinancialCard
          title="Rémunération imposable"
          value={context.state.RemExpressRemImposable}
          icon={<FaFileInvoiceDollar style={{ color: '#2563eb' }} />}
          accentColor="#2563eb"
          isEditable={true}
          onChange={(e) => context.handleCalculRemExpress("brut_imposable", "RemExpressRemImposable" , ResultatTNS, e)}
          dataType="uint"
          format={{ thousands: " ", unit: " €" }}
        />        
      </div>

      <Modal
        width="80%"
        height="82%"
        title="Situation professionnelle"
        icon={<FaGlobe />}
        visible={modalContrat}
        onClose={() => {
          context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "",  ResultatTNS, "");
          setModalContrat(false);
        }}
      >
        <RemExpressContratFacProModal
          Outil=""
          ClientConjoint={''}
          visible={modalContrat}
          onClose={() => {
            context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "",  ResultatTNS, "");
            setModalContrat(false);
          }}
        />
      </Modal>
    </div>
  );
}

export default RemExpressRemunerationTns;
